import { useListFilters } from 'commons/hooks';
import { useGetPartnersListQuery } from 'domains/Configurations/Users/usersApi';

const DEFAULT_FILTERS = { page: 1 };

function usePartnersListDesktop(skipCache = false) {
  const { filters, changeFilters } = useListFilters(
    'account/users',
    DEFAULT_FILTERS,
    false,
  );

  const changePage = (page: number) => {
    changeFilters({ ...filters, page });
  };

  const result = useGetPartnersListQuery(
    { page: filters.page, perPage: 20 },
    { skip: skipCache },
  );

  return {
    ...result,
    changePage,
    filters,
  };
}

export default usePartnersListDesktop;
